import { render, staticRenderFns } from "./TabsA.vue?vue&type=template&id=53051901&lang=pug&"
import script from "./TabsA.vue?vue&type=script&lang=js&"
export * from "./TabsA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports